/* eslint-disable no-console */
import { sendGTMEvent } from '@next/third-parties/google';
import { logAxonEvent } from './axon-events';
import { logBlotoutEvent } from './blotout-events';
import { logRudderstackEvent } from './rudderstack-events';
import { logStatsigEvent } from './statsig-events';
import { DataLayerEvent } from './types';
import { consoleLogAnalyticsEvent, enhanceDataLayerEvent } from './utils';

export const sendAnalytics = (rawDataLayerEvent: DataLayerEvent) => {
  const eventName = rawDataLayerEvent.event || rawDataLayerEvent.event_name;

  if (!eventName) {
    return;
  }

  const dataLayerEvent = enhanceDataLayerEvent(rawDataLayerEvent);

  logStatsigEvent(dataLayerEvent);
  logRudderstackEvent(dataLayerEvent);
  logBlotoutEvent(dataLayerEvent);
  logAxonEvent(dataLayerEvent);

  consoleLogAnalyticsEvent(eventName!, dataLayerEvent);

  window.dataLayer = window.dataLayer || [];

  if (dataLayerEvent.ecommerce) {
    window.dataLayer.push({ ecommerce: null });
  }

  sendGTMEvent({ ...dataLayerEvent, event_target: 'new' });
};
